
export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-3d-view-line',
      title: '3D Landscape Render Designs',
      description: 'Visualize your dream outdoor space with photorealistic 3D renderings before construction begins.',
      features: ['Photorealistic visualization', 'Multiple design options', 'Virtual walkthroughs']
    },
    {
      icon: 'ri-plant-line',
      title: 'Turf Installation',
      description: 'Premium artificial turf installation for low-maintenance, year-round green landscapes.',
      features: ['Premium materials', 'Professional installation', 'Drainage systems']
    },
    {
      icon: 'ri-seedling-line',
      title: 'Sod Installation',
      description: 'Natural grass sod installation for lush, healthy lawns that enhance your property value.',
      features: ['Quality sod selection', 'Soil preparation', 'Irrigation setup']
    },
    {
      icon: 'ri-building-line',
      title: 'Retaining Walls',
      description: 'Structural and decorative retaining walls that combine functionality with aesthetic appeal.',
      features: ['Structural engineering', 'Multiple materials', 'Drainage solutions']
    },
    {
      icon: 'ri-road-map-line',
      title: 'Paver Patios & Walkways',
      description: 'Custom paver installations creating beautiful outdoor living and entertainment areas.',
      features: ['Design flexibility', 'Durable materials', 'Pattern options']
    },
    {
      icon: 'ri-home-line',
      title: 'Fencing & Decks',
      description: 'Privacy fencing and custom deck construction for enhanced outdoor living spaces.',
      features: ['Custom designs', 'Quality materials', 'Professional installation']
    },
    {
      icon: 'ri-drop-line',
      title: 'Irrigation Systems',
      description: 'Efficient irrigation systems to keep your landscape healthy and beautiful year-round.',
      features: ['Smart controllers', 'Water efficiency', 'Zone customization']
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Outdoor Lighting',
      description: 'Landscape lighting design and installation to showcase your outdoor space after dark.',
      features: ['LED technology', 'Accent lighting', 'Security features']
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1C1C1C] mb-6 font-['Playfair_Display']">
            Our Services
          </h2>
          <p className="text-xl text-[#1C1C1C]/70 max-w-3xl mx-auto">
            From concept to completion, we offer comprehensive landscape construction services 
            that transform your outdoor vision into reality.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-[#F5F5F5] rounded-xl p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group"
            >
              <div className="w-16 h-16 bg-[#4B6043] rounded-full flex items-center justify-center mb-6 group-hover:bg-[#D9C5A0] transition-colors">
                <i className={`${service.icon} text-2xl text-white group-hover:text-[#1C1C1C]`}></i>
              </div>
              
              <h3 className="text-xl font-semibold text-[#1C1C1C] mb-3 font-['Playfair_Display']">
                {service.title}
              </h3>
              
              <p className="text-[#1C1C1C]/70 mb-4 leading-relaxed">
                {service.description}
              </p>
              
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-[#1C1C1C]/60">
                    <i className="ri-check-line text-[#4B6043] mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button 
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-[#4B6043] text-white px-8 py-4 rounded-lg hover:bg-[#3a4d35] transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line mr-2"></i>
            Request Service Quote
          </button>
        </div>
      </div>
    </section>
  );
}
